module.exports = __webpack_public_path__ + "img/cliff-entrance-shadow.ea40b1bf.png";